import _axios from 'axios'
import { AxiosError } from 'axios'

const isSSR = typeof window === 'undefined'

const axios = _axios.create({
    baseURL: process.env.NEXT_PUBLIC_API_URL,
    headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
    },
    withCredentials: true, // <-- Add this if you want to use cookies in your request (e.g. for authentication)
})

/**
 * Add a request interceptor
 *
 * ## Example
 *
 * Add an authorization header to all requests
 */
axios.interceptors.request.use((config) => {
    // * Do something before request is sent

    const store = process.env.NEXT_PUBLIC_STORE

    if (store) {
        config.headers['X-STORE'] = store
    }

    return config
})

/**
 * Add a response interceptor
 *
 * ## Example
 *
 * Handle 401 errors
 */
axios.interceptors.response.use((response) => {
    // * Do something with response data
    return response
})

declare global {
    function isAxiosError(error: unknown): boolean
}

export function isAxiosError(error: unknown): error is AxiosError {
    return (error as AxiosError).isAxiosError !== undefined
}

export default axios
